import axios from 'axios'
import library from '../../../utils/Library'

export const grantAppRoleToUserEAuthz = async (data) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL = library.getBaseAPIUrl('e_authz') + '/grantAppRoleToUserEAuthz'
  return await axios({
    url: URL,
    method: 'POST',
    data,
    headers: { Authorization: `Bearer ${TOKEN}` }
  })
}
